
















import { Component, Vue, Prop } from 'vue-property-decorator';
import { checkIfPWAInstalled, detectBrowserAndDevice, hideInstallButton } from '@/utils/pwa';

@Component({
  name: 'PWAInstallButton'
})
export default class PWAInstallButton extends Vue {
  @Prop({ default: '#7260c2' }) buttonColor!: string;
  @Prop({ default: false }) outlined!: boolean;
  @Prop({ default: false }) text!: boolean;
  @Prop({ default: true }) showIcon!: boolean;
  @Prop({ default: 'mdi-download' }) icon!: string;

  private showButton = false;
  private loading = false;
  private deferredPrompt: any = null;
  private deviceInfo: any = null;

  mounted() {
    this.checkInstallability();
    this.setupInstallPrompt();
  }

  get buttonText(): string {
    if (!this.deviceInfo) return 'Instalar App';

    if (this.deviceInfo.isIOS) {
      return 'Añadir a Inicio';
    }

    return 'Instalar App';
  }

  private checkInstallability() {
    this.deviceInfo = detectBrowserAndDevice();

    // Mostrar botón si la app no está instalada
    this.showButton = !checkIfPWAInstalled();

    // Para iOS, siempre mostrar el botón (Safari no soporta detección de instalación)
    if (this.deviceInfo.isIOS) {
      this.showButton = true;
    }
  }

  private setupInstallPrompt() {
    if (this.deviceInfo?.supportsInstallPrompt) {
      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        this.deferredPrompt = e;
        this.showButton = true;
      });

      window.addEventListener('appinstalled', () => {
        this.showButton = false;
        this.deferredPrompt = null;
      });
    }
  }

  private async handleInstallClick() {
    this.loading = true;

    try {
      if (this.deferredPrompt) {
        // Para navegadores que soportan el prompt automático
        this.deferredPrompt.prompt();
        const { outcome } = await this.deferredPrompt.userChoice;

        if (outcome === 'accepted') {
          this.showButton = false;
        }

        this.deferredPrompt = null;
      } else if (this.deviceInfo?.isIOS) {
        // Para iOS, mostrar instrucciones
        this.showIOSInstructions();
      } else {
        // Para otros casos, emitir evento
        this.$emit('install-clicked');
      }
    } catch (error) {
      console.error('Error during install:', error);
    } finally {
      this.loading = false;
    }
  }

  private showIOSInstructions() {
    const message = this.deviceInfo.isSafari
      ? 'Para instalar Beeverso:\n\n1. Toca el botón Compartir (↗️)\n2. Selecciona "Añadir a pantalla de inicio"\n3. Toca "Añadir"'
      : 'Para instalar Beeverso:\n\n1. Toca los tres puntos (...)\n2. Selecciona "Añadir a pantalla de inicio"\n3. Confirma la instalación';

    // Usar dialog de Vuetify si está disponible, si no, usar alert
    if (this.$vuetify) {
      // Emitir evento para que el componente padre maneje el diálogo
      this.$emit('show-instructions', message);
    } else {
      alert(message);
    }
  }
}
